// extracted by mini-css-extract-plugin
export default {"fondo":"Hero_fondo__HiGqz","search-bar":"Hero_search-bar__ZVQzS"};